import React, { Suspense } from "react";
import { CATEGORY,JOB_ROLE } from "constants/options";
const Sidebar = React.lazy(() => import("./sidebar"));
const SideFilter = React.lazy(() => import("./filters/side-filter"));
const DetailedViewMilestones = React.lazy(() =>
  import("./detailed-third-view")
);
const OrganizeThirdView = React.lazy(() =>
  import("./organize-position/third-view")
);

export default function ColumnView({
  selectedTab,
  filterRoles = [],
  organizeBy,
  isYourProfile,
  showFeatured,
  permission,
  options = {},
  current = [],
  past = [],
  pin = [],
  upcoming=[],
  featured = {},
  milestones = [],
  setSelectedTab = () => {},
  onWatchMedia = () => {},
  onViewImage = () => {},
  handleViewPdf = () => {},
  onEdit = () => {},
  onDelete = () => {},
  onChangeOrganizeBy = () => {},
  onChangeFeaturedOnly = () => {},
  //
  onShare = () => {},
  onReport = () => {},
  profile,
  sort,
  customOrderJR,
  customOrderCAT,
  categories,
  milestone_owner,
  translateMilestone=()=>({milestone:null,section:null,lang:"en"})
}) {
  console.log(customOrderCAT);
  return (
    <Suspense>
      <div className="w-full container-max-width mt-8">
        <div className="w-full 2sm:grid 2sm:grid-cols-5 gap-3">
          <div className="mb-5 2sm:mb-0">
            <div className="hidden md:flex bg-white rounded-md w-full justify-center px-2">
              <Sidebar  positions={options.positions}
                  {...{
                    organizeBy,
                    filterRoles,
                    showFeatured,
                    onChangeOrganizeBy,
                    onChangeFeaturedOnly,
                  }}
                  sort={sort}
                  profileType={profile?.profile_type?.type}
                  customOrderJR={customOrderJR}
                  customOrderCAT={customOrderCAT}
                  categories={categories} />
            </div>
          </div>
          <div className="col-span-4">
            <div className="grid 2sm:grid-cols-3 gap-3">
              <div className="2sm:col-span-2 order-last 2sm:order-first">
                <div className="rounded-md">
                  {organizeBy === JOB_ROLE || organizeBy === CATEGORY ? (
                    <OrganizeThirdView
                      categories={options.categories}
                      positions={options.positions}
                      {...{
                        isYourProfile,
                        featured,
                        pin,
                        upcoming,
                        milestones,
                        showFeatured,
                        permission,
                        onWatchMedia,
                        onViewImage,
                        handleViewPdf,
                        onEdit,
                        onDelete,
                        onReport,
                        profile,
                        organizeBy,
                        onShare,
                        milestone_owner,
                        translateMilestone
                      }}
                    />
                  ) : (
                    <DetailedViewMilestones
                      {...{
                        isYourProfile,
                        featured,
                        current,
                        past,
                        pin,
                        upcoming,
                        showFeatured,
                        permission,
                        onWatchMedia,
                        onViewImage,
                        handleViewPdf,
                        onEdit,
                        onDelete,
                        onShare,
                        onReport,
                        profile,
                        milestone_owner,
                        translateMilestone
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="rounded-md mb-2 2sm:mb-0">
                <SideFilter
                  positions={options.positions}
                  {...{
                    organizeBy,
                    filterRoles,
                    showFeatured,
                    onChangeOrganizeBy,
                    onChangeFeaturedOnly,
                  }}
                  sort={sort}
                  customOrderJR={customOrderJR}
                  customOrderCAT={customOrderCAT}
                  categories={categories}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Suspense>
  );
}
